export default __webpack_public_path__ + "static/media/DC_logo_mini_for web.ce53402e.png";